export const createLegalProcessDocumentService =
  (fetch) => async (legalProvisionDocument) => {
    try {
      const response = await fetch({
        url: "/api/v1/siniestros-viales/documentos-procesos-juridicos",
        method: "post",
        body: legalProvisionDocument,
        contentType: "multipart/form-data",
      });

      return response;
    } catch (error) {
      throw new Error(error.response?.data?.message || error.message);
    }
  };
